import { render, staticRenderFns } from "./RefundCard.vue?vue&type=template&id=5ff983ba&scoped=true"
import script from "./RefundCard.vue?vue&type=script&lang=js"
export * from "./RefundCard.vue?vue&type=script&lang=js"
import style0 from "./RefundCard.vue?vue&type=style&index=0&id=5ff983ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff983ba",
  null
  
)

export default component.exports